import { type Ref, forwardRef } from "react";
import type { SVGProps } from "react";
const DatabaseBase = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="1em"
    height="1em"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5 5h14v3.5h-8.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H19v3h-8.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H19V19H5zM3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm4.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(DatabaseBase);
export default ForwardRef;
